import BusinessCaseSummary from './business-case-summary';

export default BusinessCaseSummary;
